import { render, staticRenderFns } from "./DialogArtist.vue?vue&type=template&id=0fede32a"
import script from "./DialogArtist.vue?vue&type=script&lang=js"
export * from "./DialogArtist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports